export default "__VITE_ASSET__ChpBkOSR__"